/** Limites do pulse-stt-streaming-v1 (AI-1231): o pod recusa com 400 ao estourar. */
export const KEYTERM_MAX_TERMS = 100;
export const KEYTERM_MAX_TERM_CHARS = 100;
export const KEYTERM_MAX_TOTAL_CHARS = 2000;
